<template>
  <div class="romaing">
    <el-card>
      <div slot="header" class="clearfix">
        <span>虚拟漫游</span>
      </div>
      <div class="btn-box">
        <!-- <el-button type="primary" icon="el-icon-plus" size="mini"  @click="editDevice(null,false)">新建</el-button> -->
        <el-select v-model="value" size="mini" @change="selChange">
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="sw-btn">
          <!-- <el-link :underline="false" @click="refresh()"><i class="iconfont iconicon_renew"></i></el-link> -->
          <!-- <el-link :underline="false" @click="addRoam()"><i class="iconfont iconicon_collection_add"></i></el-link> -->
          <el-popover
                placement="bottom"
                trigger="hover">
                <div class="pop-cont">
                  <el-link :underline="false" type="primary" @click="addRoam()"><i class="iconfont iconicon_collection_add"></i>新增</el-link>
                  <el-link :underline="false" type="primary" @click="editRoam()"><i class="iconfont iconicon_collection_edit"></i>编辑</el-link>
                  <el-link :underline="false" type="primary" @click="delRoam()"><i class="iconfont iconicon_del"></i>删除</el-link>
                </div>
                <el-link :underline="false" slot="reference" type="primary"><i class="iconfont iconicon_collection_add1"></i></el-link>
              </el-popover>
        </div>
      </div>
      <div class="t_btn2">
        <el-table
          :data="tableData"
          empty-text="暂无数据"
          highlight-current-row
          ref="multipleTable"
          height="calc(100vh - 135px)"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{backgroundColor:'transparent',color:'#fff',fontSize:'14px',textAlign:'left',fontWeight: '500'}"
          :cell-style="{color: 'rgba(255,255,255,0.75)',backgroundColor:'transparent',fontSize:'14px',textAlign:'left',padding: '5px 0',borderBottom: '1px solid rgba(255, 255, 255, 0.1)'}"
          :row-style="{color: '#ccc',backgroundColor:'transparent',fontSize:'13px',textAlign:'left'}"
        >
          <el-table-column width="100">
            <template slot="header">
              <div style="display:flex;align-items:center;">
                <span style="margin-right:10px">序号</span>
                <i @click="addPath()" style="cursor:pointer" class="iconfont iconicon_collection_add"></i>
              </div>
            </template>
            <template slot-scope="scope">
              <div style="cursor: pointer;"
              >{{scope.row.orderNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="坐标名称">
            <template slot-scope="scope">
              <div style="cursor: pointer;"
              >{{scope.row.name}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="55">
            <template slot-scope="scope">
               <el-popover
                placement="bottom"
                trigger="hover">
                <div class="pop-cont">
                  <el-link :underline="false" type="primary" @click="editPath(scope.row)"><i class="iconfont iconicon_collection_edit"></i>编辑</el-link>
                  <el-link :underline="false" type="primary" @click="delPath(scope.row)"><i class="iconfont iconicon_del"></i>删除</el-link>
                </div>
                <el-link :underline="false" slot="reference" type="primary"><i class="iconfont iconicon_list"></i></el-link>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-dialog
      title="修改坐标"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      custom-class="path-modal"
      width="20%">
      <el-form :model="form">
        <el-form-item label="坐标序号" label-width="100px">
          <el-input v-model="form.order" autocomplete="off" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="坐标名称" label-width="100px">
          <el-input v-model="form.name" autocomplete="off" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitPath()" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <div class="fly-btns">
      <el-button type="primary" icon="el-icon-caret-right" @click="FlyAnimationfunc()">开始</el-button>
      <el-button type="primary" :icon="flyStatus? 'el-icon-video-play' : 'el-icon-video-pause'" @click="flyControl()">{{ flyStatus ? $t('menu.jx') : $t('menu.zt') }}</el-button>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/API-services"
export default {
  name: "romaing",
  data() {
    return {
      value: 1,
      options: [],
      tableData: [],
      pathId: null,
      dialogVisible: false,
      form: {
        order: null,
        name: null
      },
      editPathVal: null,
      flyStatus: false
    }
  },
  created() {
    this.getRoams()
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {
    window.StopViewAnimation()
  },
  methods: {
    flyControl() {
      this.flyStatus = !this.flyStatus
      if (this.flyStatus) {
        window.PauseViewAnimation()
      } else {
        window.ResumeViewAnimation()
      }
    },
    FlyAnimationfunc() {
      window.StopViewAnimation()
      let aniArray = []
      this.tableData.map(n => {
        aniArray.push(n.dataPath)
      })
      if (!this.playstatus) {
        window.StartViewAnimation(aniArray, 50000)
        this.playstatus = true
      } else {
        window.StopViewAnimation()
        this.playstatus = false
      }
    },
    getRoams() {
      ApiService.views.getRoam({
        id: 0,
        name: '',
        mileageID: window.R_config.modelId
      }).then(res => {
        if (res.code === 0) {
          this.options = res.data
          this.value = this.pathId || res.data[0].id
          this.getRoamPath(this.pathId || res.data[0].id)
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    getRoamPath(val) {
      this.pathId = val
      ApiService.views.getRoamPath({
        id: 0,
        roamID: val,
        name: ''
      }).then(res => {
        if (res.code === 0) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
      })
    },
    selChange(val) {
      this.getRoamPath(val)
      window.StopViewAnimation()
    },
    editPath(val) {
      this.form.name = val.name
      this.form.order = val.orderNum
      this.editPathVal = null
      this.dialogVisible = true
      this.editPathVal = val
      window.SetView(val.dataPath)
      console.log(val)
    },
    submitPath() {
      ApiService.views.addRoamPath({
        id: this.editPathVal.id,
        roamID: this.editPathVal.roamID,
        dataPath: window.GetView(),
        orderNum: [this.editPathVal.orderNum, +this.form.order],
        name: this.form.name
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '修改成功!'
          })
          this.dialogVisible = false
          this.getRoamPath(this.pathId)
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    delPath(val) {
      this.$confirm('确认删除这条坐标信息吗?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ApiService.views.delRoamPath({
          id: [val.id]
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.dialogVisible = false
            this.getRoamPath(this.pathId)
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
      })
    },
    addPath() {
      this.$prompt('坐标名称：', '添加坐标', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        ApiService.views.addRoamPath({
          roamID: this.pathId,
          dataPath: window.GetView(),
          orderNum: [],
          name: value
        }).then(res =>{
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.getRoamPath(this.pathId)
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
      })
    },
    addRoam() {
      this.$prompt('路线名称：', '添加路线', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        ApiService.views.addRoam({
          mileageID: window.R_config.modelId,
          name: value
        }).then(res =>{
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.getRoams()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
      })
    },
    editRoam() {
      this.$prompt('修改路线名称：', '编辑路线', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        ApiService.views.addRoam({
          id: this.pathId,
          mileageID: window.R_config.modelId,
          name: value
        }).then(res =>{
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
            this.getRoams()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
      })
    },
    delRoam() {
      this.$confirm('确认删除这条路线吗?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ApiService.views.delRoam({
          id: [this.pathId]
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.pathId = null
            this.value = 1
            this.getRoams()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../common/css/color.scss';
.el-popover {
  min-width: 100px;
  background:#1D2C48;
  border: 0;
}
.el-popper {
  .popper__arrow, .popper__arrow:after {
    border-bottom-color: rgba(34, 52, 85, 0.6) !important;
  }
}
.pop-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .el-link.el-link--primary {
    color: $font_color;
    &:hover {
      color: $card_header;
    }
  }
  i {
    margin-right: 10px;
  }
}
.el-select-dropdown {
  background-color: rgba(34, 52, 85, 0.6);
  border: 0;
  .el-select-dropdown__item {
    color: rgba(255, 255, 255, .85);
    // background-color: #3271C8;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: #3271C8;
  }
  .el-select-dropdown__item.selected {
    color: #fff;
    background-color: #3271C8;
  }
}
.path-modal, .el-dialog {
  background: #1D2C48 !important;
  .el-dialog__header {
    background: #3271C8;
    display: flex;
    align-items: center;
    padding: 8px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    top: 13px;
  }
  .el-form-item__label {
    color: #fff;
  }
}
.romaing {
  position: relative;
  height: calc(100vh - 40px);
  .el-card {
    border: 0;
    background: transparent;
    border-radius: 0;

    .el-card__header {
      padding: 0 10px;
      height: 40px;
      line-height: 40px;
      background-color: $card_header;
      text-align: left;
      color: $font_color;
      border-bottom: 0;
    }

    .el-card__body {
      padding: 0;
      background: rgba(2, 16, 33, 0.6);
      width: 320px;
      // bottom: 0px;
      height: calc(100vh - 40px);
    }
    .el-table {
      height: 100%;
    }
  }
}

.fly-btns {
  position: fixed;
  bottom: 1rem;
  left: 40%;
  .el-button {
    padding: 7px 20px;
    border: 0;
    &:hover {
      border: 0;
    }
  }
}
.btn-box {
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
  
  .el-select {
    width: 122px;
    border-radius: 2px;

    .el-input {
      .el-input__icon {
        line-height: 32px;
      }

      .el-input__inner {
        height: 32px;
        line-height: 32px;
        padding: 0 10px;
        border-radius: 2px;
        background-color: transparent;
      }
    }
  }
  .sw-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $font_color;
    .el-link.el-link--default {
      color: #fff;
    }
    .el-link:first-child {
      margin-right: 10px;
    }
    i {
      font-size: 24px;
    }
  }
  .el-icon-arrow-down{
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/romaing.vue